import { useQueryClient, useMutation } from "@tanstack/react-query"

import { updateUserPushConfig } from "lib/api/user/updateUserPushConfig"

const useUpdateUserPushConfigMutate = (userNo) => {
  const queryClient = useQueryClient()
  return useMutation((payload) => updateUserPushConfig(payload), {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["user-push-config", userNo] })
    },
  })
}

export default useUpdateUserPushConfigMutate
